import axios from 'axios'

export default {
  clearBookingCache () {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.delete('/api/backlog-cache-clear', {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(() => {
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },

  clearKPICache () {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.delete('/api/report/kpi/cache', {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(() => {
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },

  clearReportsPeopleAndProjectsCache () {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.delete('api/finances/report/people-and-projects/cache', {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(() => {
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  }
}
